import {createI18n} from 'vue-i18n';
import getMessages from '@core/languages';

function Choice(choice: number) {
  if (choice === 1) {
    return 0;
  }
  return 1;
}

let messages: Record<string, unknown> = {};
try {
  messages = await getMessages();
} catch (error) {
  console.error('Failed to load i18n messages', error);
}

const i18n = createI18n({
  legacy: false,
  locale: 'en-GB',
  allowComposition: true,
  fallbackLocale: 'nl-NL',
  messages,
  pluralizationRules: {
    'en-GB': Choice,
    'nl-NL': Choice,
  },
});

export default i18n;
